import { API_URL } from './api';

export const resolveMediaUrl = (media) => {
  if (!media) return null;
  const item = Array.isArray(media) ? media[0] : media;
  const formats = item?.formats || {};
  const url =
    formats?.large?.url ||
    item?.url ||
    formats?.medium?.url ||
    formats?.small?.url ||
    formats?.thumbnail?.url;
  if (!url) return null;
  return url.startsWith('http') ? url : `${API_URL}${url}`;
};

export const resolveMediaList = (media) => {
  if (!Array.isArray(media) || !media.length) return [];
  return media.map((item) => resolveMediaUrl(item)).filter(Boolean);
};

export const blogImage = (path) =>
  path ? `${process.env.PUBLIC_URL}/assets/images/${path}` : null;

export const resolveBlogCover = (blog) =>
  resolveMediaUrl(blog.coverImage) ||
  (blog.coverImagePath ? blogImage(blog.coverImagePath) : null);

export const resolveBlogInline = (blog) => resolveMediaUrl(blog.inlineImage);
